var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-forget-password"},[_c('MoleculeForgetPassword')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }